import { ComponentsModule } from '../../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { UserTaskClosedListPage } from './user-task-closed-list';

@NgModule({
  declarations: [UserTaskClosedListPage],
  imports: [
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(UserTaskClosedListPage),
    ComponentsModule,
  ],
})
export class UserTaskClosedListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-closed-list/user-task-closed-list.module.ts